import { render, staticRenderFns } from "./dropdowncontainer.vue?vue&type=template&id=c5fec4c2&scoped=true&"
import script from "./dropdowncontainer.vue?vue&type=script&lang=js&"
export * from "./dropdowncontainer.vue?vue&type=script&lang=js&"
import style0 from "./dropdowncontainer.vue?vue&type=style&index=0&id=c5fec4c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fec4c2",
  null
  
)

export default component.exports